import { fb, validators } from '../../../lib/form';

export function getContactModel(data) {
  const model = fb.group({
    name: [data.name || '', [validators.Required()], { label: 'Name', type: 'text' }],
    phone: [data.phone || '', [validators.Required()], { label: 'Phone', type: 'text' }],
    email: [data.email || '', [validators.Required(), validators.Email()], { label: 'Email', type: 'email' }],
    enquiry: [data.enquiry || '', [validators.Required()], { label: 'Your Message', type: 'textarea' }],
    attachments: [data.attachments || '', [], { label: 'Attachments', type: 'file' }],
    // mailchimp: [
    //   "",
    //   [],
    //   {
    //     label:
    //       "Yes! Sign me up to your E-Newsletter to get all the Latest News, Events & Offers.",
    //     type: "checkbox",
    //   },
    // ],
  }); 
  return model;
}